/**
 * Loading Skeleton Component
 * 
 * Reusable loading skeleton for better UX during data fetching.
 */

import React from 'react';
import { Box, Skeleton } from '@mui/material';

interface LoadingSkeletonProps {
  /** Number of skeleton items */
  count?: number;
  /** Height of each skeleton */
  height?: number;
  /** Variant: 'text', 'rectangular', 'circular' */
  variant?: 'text' | 'rectangular' | 'circular';
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({
  count = 3,
  height = 60,
  variant = 'rectangular',
}) => {
  return (
    <Box>
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton
          key={index}
          variant={variant}
          height={height}
          sx={{ mb: 2 }}
          animation="wave"
        />
      ))}
    </Box>
  );
};

export default LoadingSkeleton;

